import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import "./Bid.css";
import {
  getBidDepositBuyerInfo,
  getBidPageDetail,
} from "@/api/bidDepositApiHold";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDepositData } from "@/bidFeature/bidSlice";
import { Col, Container, Row } from "react-bootstrap";
import { trackButtonClick } from "@/utils/analytics";
function SuccessMessage({
  paymentReferenceNumber,
  showMessage,
  onNavigate,
  paymentFlag,
  WinningEmail,
  fraudlentSection,
  fraudlentAmount,
}) {
  const [bidData, setBidData] = useState({});
  const [buyerInfo, setBuyerInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const selector = useSelector((state) => state?.pdp?.bidCenterData);
  const bid_selector = useSelector((state) => state?.bidwizardStage?.Stage);
  const selectorAmount = useSelector(
    (state) => state?.bidwizardStage?.BidAmount
  );
  const userBid_email = useSelector(
    (state) => state?.userSliceDetails?.cifResponseData?.buyer?.email
  );
  // console.log("userBid_email", userBid_email);

  // console.log("selector", bid_selector);
  const { bidRequest, validationResult } = bid_selector || {};
  // console.log("selector", selector);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   const fetchBidDepositInfo = async () => {
  //     try {
  //       if (showMessage && selector?.listingId) {
  //         const response = await getBidDepositBuyerInfo(
  //           selector.listingId,
  //           userBid_email
  //         );
  //         console.log("Bid deposit info:", response?.data?.data?.buyer?.email);
  //         setBuyerInfo(response?.data?.data);
  //         // Handle the response data here
  //       }
  //     } catch (error) {
  //       console.error("Error fetching bid deposit info:", error);
  //       // Handle error here
  //     }
  //   };

  //   fetchBidDepositInfo();
  // }, [showMessage, selector?.listingId]); // Dependencies array
  const handlegetBidPageDetail = () => {
    setIsLoading(true);

    const payload = {
      bidAmount: fraudlentSection
        ? fraudlentAmount
        : selector?.startingBidAmount,
      bidType: "PLACE_BID",
      buyerEmailId: "",
      listingId: selector.listingId,
    };
    getBidPageDetail(payload)
      .then((response) => {
        // console.log("getBidPageDetail", response?.data?.data);
        dispatch(setDepositData(response?.data?.data));
        setBidData(response?.data?.data);
        trackButtonClick({
          pageName: "proceed_to_bid_click",
          eventCategory: "Bid Participation Page",
          eventSource: "on payment success",
          eventParams: { page_name: "payment_response_page" },
          eventLabel: `${selector?.listingId} | SRC : NewBidWizard`,
        });
        onNavigate(4);
      })
      .catch((error) => {
        console.error("Error in getBidPageDetail:", error);
        alert("Failed to process your request. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    // <Card className="text-center container shadow p-3 mb-5 bg-white">
    //   <Card.Title></Card.Title>
    //   <Card.Body>
    //     <Card.Title className="success_msg ">
    //       <i className="bi bi-check-circle check_icon"></i>
    //       <br />
    //       Congratulations! <br /> You are Now ready to Bid!
    //     </Card.Title>
    //     <b>Your Transcaction was successfull.</b>
    //     <Card.Text>
    //       ${" "}
    //       {validationResult?.bidDepositAmount ||
    //         selectorAmount?.bidDepositAmount}
    //       Bid Deposit hold and ${" "}
    //       {validationResult?.bidDepositChargeAmount ||
    //         selectorAmount?.bidDepositChargeAmount}
    //       Non-refundable charge Reference Number:
    //       {buyerInfo?.id || "c50b315c-589b-4428-88c4-fd58e3a8b0a9"}
    //     </Card.Text>
    //     <Card.Text style={{ color: "#8f859b" }}>
    //       A receipt of the order confirmation and copy of bid Deposit terms will
    //       be sent to your email address {buyerInfo?.buyer?.email}
    //     </Card.Text>
    //     <Button
    //       variant="primary"
    //       // className="buttonlg"
    //       size="lg"
    //       onClick={handlegetBidPageDetail}
    //     >
    //       Continue
    //     </Button>
    //   </Card.Body>
    // </Card>
    // <Card className="text-center container shadow p-3 mb-5 bg-white">
    //   <Card.Body>
    //     <Card.Title className="success_msg">
    //       <div className="heading-img">
    //         <svg
    //           version="1.0"
    //           xmlns="http://www.w3.org/2000/svg"
    //           xmlnsXlink="http://www.w3.org/1999/xlink"
    //           x="0px"
    //           y="0px"
    //           viewBox="0 0 24 24"
    //           style={{
    //             enableBackground: "new 0 0 24 24",
    //             height: "80px",
    //             width: "80px",
    //           }}
    //         >
    //           <g>
    //             <path
    //               style={{ fill: "#1CBF21" }}
    //               d="M12,1.01c-6.07,0-11,4.93-11,11s4.93,11,11,11c6.07,0,11-4.93,11-11S18.07,1.01,12,1.01L12,1.01z M12,22.16
    //             c-5.6,0-10.15-4.55-10.15-10.15C1.85,6.41,6.4,1.86,12,1.86c5.6,0,10.15,4.55,10.15,10.15C22.15,17.61,17.6,22.16,12,22.16
    //             L12,22.16z M12,22.16"
    //             />
    //           </g>
    //           <g>
    //             <path
    //               style={{ fill: "#1CBF21" }}
    //               d="M17.61,8.26l-6.79,6.66L7.3,11.54l-0.65,0.65l4.16,4.16l7.44-7.44L17.61,8.26z M17.47,8.13"
    //             />
    //           </g>
    //         </svg>
    //       </div>
    //       <br />
    //     </Card.Title>
    //     Congratulations! <br />
    //     You are now ready to Bid!
    //     <b>Your Transaction was successful.</b>
    //     <Card.Text>
    //       {/* ${" "}
    //       {(
    //         validationResult?.bidDepositAmount ||
    //         selectorAmount?.bidDepositAmount
    //       )?.toLocaleString()}
    //       Bid Deposit hold and ${" "}
    //       {validationResult?.bidDepositChargeAmount ||
    //         selectorAmount?.bidDepositChargeAmount}
    //       Non-refundable charge Reference Number:
    //       {paymentReferenceNumber || "c50b315c-589b-4428-88c4-fd58e3a8b0a9"} */}
    //       ${" "}
    //       {(
    //         validationResult?.bidDepositAmount ||
    //         selectorAmount?.bidDepositAmount
    //       )?.toLocaleString()}{" "}
    //       Bid deposit hold reference number: {paymentReferenceNumber || ""}
    //     </Card.Text>
    //     <Card.Text style={{ color: "#8f859b" }}>
    //       A receipt of the order confirmation and a copy of the bid deposit
    //       terms will be sent to your email address {buyerInfo?.buyer?.email}
    //     </Card.Text>
    //     <Button variant="primary" size="lg" onClick={handlegetBidPageDetail}>
    //       Continue
    //     </Button>
    //   </Card.Body>
    // </Card>
    // <Card className="text-center container shadow p-3 mb-5 bg-white">
    //   <Card.Body>
    //     <Card.Title className="success_msg">
    // <div className="heading-img">
    //   <svg
    //     version="1.0"
    //     xmlns="http://www.w3.org/2000/svg"
    //     xmlnsXlink="http://www.w3.org/1999/xlink"
    //     x="0px"
    //     y="0px"
    //     viewBox="0 0 24 24"
    //     style={{
    //       enableBackground: "new 0 0 24 24",
    //       height: "80px",
    //       width: "80px",
    //     }}
    //   >
    //     <g>
    //       <path
    //         style={{ fill: "#1CBF21" }}
    //         d="M12,1.01c-6.07,0-11,4.93-11,11s4.93,11,11,11c6.07,0,11-4.93,11-11S18.07,1.01,12,1.01L12,1.01z M12,22.16
    //       c-5.6,0-10.15-4.55-10.15-10.15C1.85,6.41,6.4,1.86,12,1.86c5.6,0,10.15,4.55,10.15,10.15C22.15,17.61,17.6,22.16,12,22.16
    //       L12,22.16z M12,22.16"
    //       />
    //     </g>
    //     <g>
    //       <path
    //         style={{ fill: "#1CBF21" }}
    //         d="M17.61,8.26l-6.79,6.66L7.3,11.54l-0.65,0.65l4.16,4.16l7.44-7.44L17.61,8.26z M17.47,8.13"
    //       />
    //     </g>
    //   </svg>
    // </div>
    //     </Card.Title>
    //     <Container>
    //       <Row className="justify-content-center">
    //         <Col xs={12} md={10} lg={8}>
    //           <div className="message-content">
    //             <h4 className="mb-2">
    //               Congratulations! <br />
    //               You are now ready to Bid!
    //             </h4>
    //             <h5 className="mb-3">
    //               <b>Your Transaction was successful.</b>
    //             </h5>
    //             <Card.Text className="mb-3">
    //               ${" "}
    //               {(
    //                 validationResult?.bidDepositAmount ||
    //                 selectorAmount?.bidDepositAmount
    //               )?.toLocaleString()}{" "}
    //               Bid deposit hold reference number:{" "}
    //               {paymentReferenceNumber || ""}
    //             </Card.Text>
    //             <Card.Text style={{ color: "#8f859b" }} className="mb-4">
    //               A receipt of the order confirmation and a copy of the bid
    //               deposit terms will be sent to your email address{" "}
    //               {buyerInfo?.buyer?.email}
    //             </Card.Text>
    //           </div>
    //           <Button
    //             variant="primary"
    //             size="lg"
    //             onClick={handlegetBidPageDetail}
    //             className="px-4"
    //           >
    //             Continue
    //           </Button>
    //         </Col>
    //       </Row>
    //     </Container>
    //   </Card.Body>
    // </Card>
    // <Card className="text-center container mb-5 bg-white">
    //   <Card.Body>
    //     <Card.Title className="success-message-title">
    //       <div className="success-message-icon">
    //         <svg
    //           version="1.0"
    //           xmlns="http://www.w3.org/2000/svg"
    //           xmlnsXlink="http://www.w3.org/1999/xlink"
    //           x="0px"
    //           y="0px"
    //           viewBox="0 0 24 24"
    //           style={{
    //             enableBackground: "new 0 0 24 24",
    //             height: "80px",
    //             width: "80px",
    //           }}
    //         >
    //           <g>
    //             <path
    //               style={{ fill: "#1CBF21" }}
    //               d="M12,1.01c-6.07,0-11,4.93-11,11s4.93,11,11,11c6.07,0,11-4.93,11-11S18.07,1.01,12,1.01L12,1.01z M12,22.16
    //             c-5.6,0-10.15-4.55-10.15-10.15C1.85,6.41,6.4,1.86,12,1.86c5.6,0,10.15,4.55,10.15,10.15C22.15,17.61,17.6,22.16,12,22.16
    //             L12,22.16z M12,22.16"
    //             />
    //           </g>
    //           <g>
    //             <path
    //               style={{ fill: "#1CBF21" }}
    //               d="M17.61,8.26l-6.79,6.66L7.3,11.54l-0.65,0.65l4.16,4.16l7.44-7.44L17.61,8.26z M17.47,8.13"
    //             />
    //           </g>
    //         </svg>
    //       </div>
    //     </Card.Title>
    //     <Container>
    //       <Row className="justify-content-center">
    //         <Col xs={12} md={10} lg={8}>
    //           <div className="success-message-content">
    //             <h4 className="success-message-congratulations">
    //               Congratulations! <br />
    //               You are now ready to Bid!
    //             </h4>
    //             <h5 className="success-message-status">
    //               <b>Your Transaction was successful.</b>
    //             </h5>
    //             <Card.Text className="success-message-details">
    //               ${" "}
    //               {(
    //                 validationResult?.bidDepositAmount ||
    //                 selectorAmount?.bidDepositAmount
    //               )?.toLocaleString()}{" "}
    //               Bid deposit hold reference number:{" "}
    //               {paymentReferenceNumber || ""}
    //             </Card.Text>
    //             <Card.Text className="success-message-email">
    //               A receipt of the order confirmation and a copy of the bid
    //               deposit terms will be sent to your email address{" "}
    //               {buyerInfo?.buyer?.email}
    //             </Card.Text>
    //           </div>
    //           <Button
    //             variant="primary"
    //             size="lg"
    //             onClick={handlegetBidPageDetail}
    //             className="success-message-button"
    //           >
    //             Continue
    //           </Button>
    //         </Col>
    //       </Row>
    //     </Container>
    //   </Card.Body>
    // </Card>
    <>
      <Row className="justify-content-center">
        <Col xs={12} sm={10} md={12} lg={12}>
          <Card className="text-center bid-deposit-card">
            <Card.Body>
              <Card.Title className="success-message-title">
                <div className="heading-img">
                  <svg
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 24 24"
                    style={{
                      enableBackground: "new 0 0 24 24",
                      height: "80px",
                      width: "80px",
                    }}
                  >
                    <g>
                      <path
                        style={{ fill: "#1CBF21" }}
                        d="M12,1.01c-6.07,0-11,4.93-11,11s4.93,11,11,11c6.07,0,11-4.93,11-11S18.07,1.01,12,1.01L12,1.01z M12,22.16
                c-5.6,0-10.15-4.55-10.15-10.15C1.85,6.41,6.4,1.86,12,1.86c5.6,0,10.15,4.55,10.15,10.15C22.15,17.61,17.6,22.16,12,22.16
                L12,22.16z M12,22.16"
                      />
                    </g>
                    <g>
                      <path
                        style={{ fill: "#1CBF21" }}
                        d="M17.61,8.26l-6.79,6.66L7.3,11.54l-0.65,0.65l4.16,4.16l7.44-7.44L17.61,8.26z M17.47,8.13"
                      />
                    </g>
                  </svg>
                </div>
              </Card.Title>
              <div className="success-message-content">
                <h4 className="success-message-congratulations">
                  Congratulations! <br />
                  {!paymentFlag && <> You are now ready to Bid!</>}
                </h4>
                <h5 className="success-message-status">
                  <b>Your Transaction was successful.</b>
                </h5>
                {/* <Card.Text className="success-message-details">
                  $
                  {(
                    validationResult?.bidDepositAmount ||
                    selectorAmount?.bidDepositAmount
                  )?.toLocaleString()}{" "}
                  Bid deposit hold and $
                  {(
                    validationResult?.bidDepositChargeAmount ||
                    selectorAmount?.bidDepositChargeAmount
                  )?.toLocaleString()}{" "}
                  {!paymentFlag && <>Non-refundable charge </>}
                  reference number: {paymentReferenceNumber || ""}
                </Card.Text> */}
                <Card.Text className="success-message-details">
                  $
                  {(
                    validationResult?.bidDepositAmount ||
                    selectorAmount?.bidDepositAmount
                  )?.toLocaleString()}{" "}
                  Bid deposit hold
                  {(validationResult?.bidDepositChargeAmount ||
                    selectorAmount?.bidDepositChargeAmount) && (
                    <>
                      {" "}
                      and $
                      {(
                        validationResult?.bidDepositChargeAmount ||
                        selectorAmount?.bidDepositChargeAmount
                      )?.toLocaleString()}{" "}
                      {!paymentFlag && <>Non-refundable charge</>}
                    </>
                  )}{" "}
                  reference number: {paymentReferenceNumber || ""}
                </Card.Text>
                <Card.Text className="success-message-email">
                  A receipt of the order confirmation and a copy of the bid
                  deposit terms will be sent to your email address{" "}
                  {paymentFlag
                    ? WinningEmail
                    : buyerInfo?.buyer?.email || userBid_email}
                </Card.Text>
              </div>
              {!paymentFlag && (
                <Button
                  variant="primary"
                  size="lg"
                  onClick={handlegetBidPageDetail}
                  disabled={isLoading}
                  className="success-message-button"
                >
                  {isLoading ? (
                    <span>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Processing...
                    </span>
                  ) : (
                    "Continue"
                  )}
                </Button>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* <Button
        variant="primary"
        size="lg"
        onClick={handlegetBidPageDetail}
        className="success-message-button"
      >
        Continue
      </Button> */}
    </>

    // <Card className="success-msg-container text-center">
    //   {/* Add confetti elements */}
    //   {[...Array(15)].map((_, i) => (
    //     <div
    //       key={i}
    //       className="confetti"
    //       style={{
    //         left: `${Math.random() * 100}%`,
    //         animationDelay: `${Math.random() * 3}s`,
    //       }}
    //     />
    //   ))}
    //   <Card className="success-msg-container text-center">
    //     <Card.Body className="success-msg-card">
    //       <div className="success-msg-header">
    //         <div className="success-msg-icon-container">
    //           <i className="bi bi-check-circle-fill"></i>
    //         </div>
    //         <h3 className="success-msg-title">Congratulations!</h3>
    //         <p className="text-white mt-2">You are Now ready to bid!</p>
    //       </div>

    //       <div className="success-msg-content">
    //         <h4
    //           className="mt-4"
    //           style={{ color: "#4a2baf", fontWeight: "600" }}
    //         >
    //           Your Transaction was successful
    //         </h4>

    //         <p className="success-msg-text">
    //           <span className="highlight-value amount-value">
    //             ${validationResult?.bidDepositAmount}
    //           </span>
    //           Bid Deposit hold and
    //           <span className="highlight-value amount-value">
    //             ${validationResult?.bidDepositChargeAmount}
    //           </span>
    //           Non-refundable charge
    //           <br />
    //           Reference Number:{" "}
    //           <span className="highlight-value">{buyerInfo?.id}</span>
    //         </p>

    //         <div className="success-msg-divider"></div>

    //         <p className="success-msg-text">
    //           A receipt of the order confirmation and copy of bid Deposit terms
    //           will be sent to your email address{" "}
    //           <span className="email-value">{buyerInfo?.buyer?.email}</span>
    //         </p>

    //         <Button
    //           variant="primary"
    //           size="lg"
    //           onClick={handlegetBidPageDetail}
    //           className="success-msg-button"
    //         >
    //           Continue
    //         </Button>
    //       </div>
    //     </Card.Body>
    //   </Card>
    // </Card>
    // <Card className="text-center container shadow p-3 mb-5 bg-white">
    //   {/* Add confetti elements */}
    //   {/* {[...Array(15)].map((_, i) => (
    //     <div
    //       key={i}
    //       className="confetti"
    //       style={{
    //         left: `${Math.random() * 100}%`,
    //         animationDelay: `${Math.random() * 3}s`,
    //         background: ["#ffd700", "#4a2baf", "#2da94f"][
    //           Math.floor(Math.random() * 3)
    //         ],
    //       }}
    //     />
    //   ))} */}
    //   {/* <Card.Body>
    //     <div className="success-msg-header rounded-top p-4">
    //       <div className="success-msg-icon-container mb-3">
    //         <i className="bi bi-check-circle-fill"></i>
    //       </div>
    //       <h3 className="success-msg-title mb-2">Congratulations!</h3>
    //       <p className="text-white">You are Now ready to bid!</p>
    //     </div>

    //     <div className="p-4">
    //       <h4
    //         className="mt-3 mb-4"
    //         style={{ color: "#4a2baf", fontWeight: "600" }}
    //       >
    //         Your Transaction was successful
    //       </h4>

    //       <Row className="justify-content-center">
    //         <Col xs={12} md={10}>
    //           <div className="success-msg-text p-3 mb-3">
    //             <Row className="mb-2">
    //               <Col xs={12} sm={6} className="mb-2 mb-sm-0">
    //                 <span className="highlight-value amount-value d-inline-block">
    //                   $
    //                   {validationResult?.bidDepositAmount ||
    //                     selectorAmount?.bidDepositAmount}
    //                 </span>{" "}
    //                 Bid Deposit hold
    //               </Col>
    //               <Col xs={12} sm={6}>
    //                 <span className="highlight-value amount-value d-inline-block">
    //                   $
    //                   {validationResult?.bidDepositChargeAmount ||
    //                     selectorAmount?.bidDepositChargeAmount}
    //                 </span>{" "}
    //                 Non-refundable charge
    //               </Col>
    //             </Row>
    //             <div className="mt-2">
    //               Reference Number:{" "}
    //               <span className="highlight-value">
    //                 {buyerInfo?.id || "c50b315c-589b-4428-88c4-fd58e3a8b0a9"}
    //               </span>
    //             </div>
    //           </div>
    //         </Col>
    //       </Row>

    //       <div className="success-msg-divider my-4"></div>

    //       <Row className="justify-content-center">
    //         <Col xs={12} md={10}>
    //           <div className="success-msg-text p-3">
    //             <p className="mb-2">
    //               A receipt of the order confirmation and copy of bid Deposit
    //               terms will be sent to your email address
    //             </p>
    //             <span className="email-value d-inline-block">
    //               {buyerInfo?.buyer?.email}
    //             </span>
    //           </div>
    //         </Col>
    //       </Row>

    //       <Button
    //         variant="primary"
    //         size="lg"
    //         onClick={handlegetBidPageDetail}
    //         className="success-msg-button mt-4"
    //       >
    //         Continue
    //       </Button>
    //     </div>
    //   </Card.Body> */}
    // </Card>
  );
}

export default SuccessMessage;
